<template>
  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/activityManagement')">活动管理</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size="small"
          :model="filters"
        >
          <el-form-item label="活动名称">
            <el-input
              style="width:300px"
              v-model="filters.keyword"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="参加方式">
            <el-select
              v-model="filters.infoType"
              clearable
            >
              <el-option
                label="发货数量"
                value='1'
              ></el-option>
              <el-option
                label="购进数量"
                value="2"
              ></el-option>
              <el-option
                label="购进金额"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="filters.status"
              clearable
            >
              <el-option
                label="待上架"
                value="1"
              ></el-option>
              <el-option
                label="上架中"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('120003')"
              style="margin-left:10px"
              @click="addOrUpOne1"
              type="primary"
              size="small"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div>-->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name="objectSpanMethod"
        >
          <el-table-column
            prop="title"
            width="180"
            label="标题"
          ></el-table-column>

          <el-table-column
            prop="listPic"
            width="180"
            label="列表图片"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.listPic"
                style="width:50px;"
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="infoType"
            width="180"
            label="参加方式"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.infoType == 1">发货数量</div>
              <div v-else-if="scope.row.infoType == 2">购进数量</div>
              <div v-else>购进金额</div>
            </template>
          </el-table-column>



          <el-table-column
            prop="needBuyGoodIds"
            width="180"
            label="限制购买的商品"
          >
            <template slot-scope="scope">
              <el-button
                @click="openList(scope.row.needGoodIds)"
                type="text"
                size="small"
              >查看</el-button>
            </template>
          </el-table-column>

          <el-table-column
            prop="activityGoodIds"
            width="180"
            label="活动优惠的商品"
          >
            <template slot-scope="scope">
              <el-button
                @click="openGoodList(scope.row)"
                type="text"
                size="small"
              >查看</el-button>
            </template>
          </el-table-column>

          <el-table-column
            prop="noBuyRoleTypes"
            width="180"
            label="限制代理等级"
          >
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.noBuyRoleTypes1" :key="index">
                <div v-if="item == '-0.5'">康减系列VIP会员</div>
                <div v-else-if="item == '-0.4'">康减系列高级会员</div>
                <div v-else-if="item == '-0.3'">康减系列荣誉会员</div>
                <div v-else-if="item == '1.1'">康减系列市代</div>
                <div v-else-if="item == '2.1'">康减系列省代</div>
                <div v-else-if="item == '3.1'">康减系列CEO</div>
                <div v-else-if="item == '0'">VIP门店</div>
                <div v-else-if="item == '1.0'">联盟店</div>
                <div v-else-if="item == '1.05'">优秀联盟店</div>
                <div v-else-if="item == '2.0'">市代</div>
                <div v-else-if="item == '3.0'">省代</div>
                <div v-else-if="item == '4.0'">CEO</div>
                <div v-else-if="item == '5.0'">总经销商</div>

                <div v-else-if="item == '2.2'">合伙人</div>
                <div v-else-if="item == '4.2'">董事</div>
                <div v-else-if="item == '5.1'">区域总监</div>
                <div v-else-if="item == '5.2'">城市加盟商</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="desction"
            width="180"
            label="简介"
          ></el-table-column>

          <el-table-column
            prop="createTime1"
            width="180"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            prop="startTime1"
            width="180"
            label="活动开始时间"
          ></el-table-column>
          <el-table-column
            prop="endTime1"
            width="180"
            label="活动结束时间"
          ></el-table-column>
          <el-table-column
            prop="valideTime1"
            width="180"
            label="特权到期时间"
          ></el-table-column>

          <el-table-column
            prop="steps1"
            width="180"
            label="满足条件阶梯"
          >
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.steps1" :key="index">
                <div>满足<span v-if="scope.row.infoType == 3">金额：</span><span v-if="scope.row.infoType != 3">数量：</span> {{ item.limitNum }}, 赠送数量: {{ item.sendNum }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            width="180"
            label="活动状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >待上架</el-tag>
              <el-tag
                v-if="scope.row.status == 2"
                disable-transitions
              >已上架</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="100"
          >
            <template slot-scope="scope">
            <el-button
                @click="goAcUser(scope.row)"
                type="text"
                size="small"
              >参与用户</el-button>
              <el-button v-if="hasPower('120003')"
                @click="addOrUpOne(scope.row)"
                type="text"
                size="small"
              >修改</el-button>
              <template v-if="hasPower('120003') && scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >上架</el-button>
              </template>
              <template v-if="hasPower('120003') && scope.row.status == 2">
                <el-button
                  @click="upHouseStatus(scope.row,1)"
                  type="text"
                  size="small"
                >下架</el-button>
              </template>

              <el-button v-if="hasPower('120003')"
                @click="upHouseStatus(scope.row,3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count="total_page"
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="限制购买的商品"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading"
        :data="openList1"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="id"
          label="序号"
        >
        </el-table-column>

        <el-table-column
          prop="pic"
          label="图片"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.pic"
              style="width:50px;"
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="名称"
        >
        </el-table-column>
      </el-table>
<!--      <div class="pageDiv block">-->
<!--        <el-pagination-->
<!--          @size-change="handleSizeChange"-->
<!--          @current-change="handleCurrentChange1"-->
<!--          :current-page.sync="page_num1"-->
<!--          :page-count='total_page1'-->
<!--          :page-size="page_size1"-->
<!--          layout="total, prev, pager, next"-->
<!--          :total="total_num1"-->
<!--        >-->
<!--        </el-pagination>-->
<!--      </div>-->

    </el-dialog>

    <el-dialog
      title="活动优惠的商品"
      :visible.sync="subListVisible1"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading"
        :data="openGoodList1"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="goodId"
          label="序号"
        >
        </el-table-column>

        <el-table-column
          prop="pic"
          label="图片"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.pic"
              style="width:50px;"
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="名称"
        >
        </el-table-column>

        <el-table-column
          prop="price"
          label="优惠金额"
        >
        </el-table-column>
      </el-table>
      <!--      <div class="pageDiv block">-->
      <!--        <el-pagination-->
      <!--          @size-change="handleSizeChange"-->
      <!--          @current-change="handleCurrentChange1"-->
      <!--          :current-page.sync="page_num1"-->
      <!--          :page-count='total_page1'-->
      <!--          :page-size="page_size1"-->
      <!--          layout="total, prev, pager, next"-->
      <!--          :total="total_num1"-->
      <!--        >-->
      <!--        </el-pagination>-->
      <!--      </div>-->

    </el-dialog>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "money_out_list",
  created() {},

  data() {
    return {
      listLoading: false,
      picList: [],
      filters: {
        keyword: null,
        infoType: null,
        status: null,
      },
      detailListLoading: false,
      page_num: 1,
      tableDetailData: null,
      keywords: "",
      tableData: [],
      total_num: 0,
      totalMoney: 0,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
      subListVisible: false,
      subListVisible1: false,
      activityId: null,
      page_num1: 1,
      tableData1: [],
      total_num1: 0,
      total_page1: 0,
      page_size1: 10,
      openList1: [],
      openGoodList1: [],
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  activated() {
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    openList (row) {
      this.openList1 = JSON.parse(row)
      console.log(JSON.parse(row))
      this.subListVisible = true;
    },
    openGoodList (row) {
      // scope.row.activityGoodIds, scope.row.needGoodIds
      if (row.acType != 2)
      {
        this.openGoodList1 = JSON.parse(row.activityGoodIds)
      } else {
        var list = [];
        JSON.parse(row.needGoodIds).forEach(item => {
          list.push({
            goodId:item.buyGoodId,
            name:item.buyGoodName,
            pic:item.buyPic,
            price:item.price
          })    
        })
        this.openGoodList1 = list;
      }
      
      this.subListVisible1 = true;
    },
    excelOut(row) {
      var that = this;
      var url =
        "/manager/user/pc/send_list_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&acName=" + row.info_name;
      url = url + "&activityId=" + row.id;

      top.location.href = url;
    },
    showDetailInfos(row) {
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.activityId = row.id;
      this.searchDetail(this.askRoleType);
    },

    addOrUpOne(row) {
      this.$router.push({
        path: "/add_activityManagement",
        query: { activity: JSON.stringify(row) }
      });
    },
    addOrUpOne1() {
      this.$router.push({
        path: "/add_activityManagement"
      });
    },
    goAcUser(row) {
      this.$router.push({
        path: "/acUserList",
        query: { acId: row.id, acName:row.title, infoType:row.infoType }
      });
    },
    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("上架后，APP将可以参与该活动", "确定上架吗?", {
          type: "info"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: status
            };
            API.up_activity_status(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "上架成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm(
          "下架后，APP将不能参与该活动",
          "确定下架吗?",
          { type: "info" }
        )
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: status
            };
            API.up_activity_status(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
        let that = this;
        this.$confirm("删除后，前后台都看不到此活动", "确定删除吗？", {
          type: "info"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: status
            };
            API.up_activity_status(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.keyword) {
        params.keyword = that.filters.keyword;
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      that.listLoading = true;
      API.activity_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.totalMoney = result.result.data;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].createTime1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].createTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].startTime1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].startTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].endTime1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].endTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].valideTime1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].valideTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].noBuyRoleTypes1 = result.result.list[i].noBuyRoleTypes.split(",")
                  if (result.result.list[i].steps && result.result.list[i].steps != null)
                  {
                    result.result.list[i].steps1 = JSON.parse(result.result.list[i].steps)
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    handleCurrentChange1(val) {
      this.searchDetail();
    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        activityId: that.activityId,
        pageNum: that.page_num1,
        pageSize: that.page_size1
      };
      that.detailListLoading = true;
      API.send_order_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num1 = result.result.count;
            that.total_page1 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/activityManagement.vue